const SectionController = function(isHovering, element) {
    const videoElement = element.getElementsByTagName("video")[0];
    VideoController(isHovering, videoElement)
}

const VideoController = function(isHovering, videoElement)
{
    if (isHovering == true)
    {
        videoElement.play();
        if(document.getElementById('wp-presentation')) {
            document.getElementById('wp-presentation').classList.add('hover')
        }

    }
    else if (isHovering == false)
    {
        videoElement.pause();
        if (document.getElementById('wp-presentation')) {
            document.getElementById('wp-presentation').classList.remove('hover');
        }
    }
}